var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "400",
      "content-class": "rounded-xl",
      "persistent": _vm.loading
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', _vm._b({}, 'v-card', {
    loading: _vm.loading
  }, false), [_c('v-card-title', [_vm._v("수동 보고서 생성")]), _c('v-card-text', [_c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', _vm._b({
    staticClass: "text-caption",
    attrs: {
      "type": "number",
      "min": "2023",
      "max": "2099",
      "suffix": "년"
    },
    model: {
      value: _vm.form.year,
      callback: function ($$v) {
        _vm.$set(_vm.form, "year", $$v);
      },
      expression: "form.year"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', _vm._b({
    staticClass: "text-caption",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "12",
      "suffix": "월"
    },
    model: {
      value: _vm.form.month,
      callback: function ($$v) {
        _vm.$set(_vm.form, "month", $$v);
      },
      expression: "form.month"
    }
  }, 'v-text-field', _vm.attrs_input, false))], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "justify-end"
  }, [_c('v-btn', _vm._b({
    attrs: {
      "text": "",
      "color": "red"
    },
    on: {
      "click": function ($event) {
        _vm.shows = false;
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("취소하기")]), _c('v-btn', _vm._b({
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("생성하기")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }